import { ActivityComponentType } from '@stackflow/react'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_achievement } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { AchievementsBody } from '../../../pages/[lang]/portal/my-ringle/achievements'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AchievementsTobNav = () => {
  const { t } = useTranslation()

  return <div className="Body1-16Md">{t(n_achievement.title)}</div>
}

const AchievementsActivity: ActivityComponentType = () => {
  const appRouter = useAppRouter()

  return (
    <WebviewStackContainer height="52px" onBack={() => appRouter.back()} title={<AchievementsTobNav />} border={false}>
      <AchievementsBody />
    </WebviewStackContainer>
  )
}

export default AchievementsActivity
